import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import template from './InstallationCard.rt';
import * as actions from '../../actions';
import {selectItemUpdates, hasFabricatorItems} from '../../selectors';
import {AccessRights} from "../../schemas/accessRightsModel";
import * as helpers from '../../utilities/helpers';
import _ from 'lodash';
import {hashHistory} from 'react-router';

function mapStateToProps(state, props) {
  const {installationGroup} = props;

  const AR = AccessRights.get(state);

  return {
    updatedInstallationGroup: selectItemUpdates(state, installationGroup),
    hasFabricatorItems: hasFabricatorItems(state, installationGroup),
    canEnableInstallationsGroups: AR.isSiteAdmin(false) || AR.isFabMaster() || AR.isFabAdmin(),
    AR,
    installationGroup
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onUpdateTransientField: (key, value) => dispatch(actions.updateTransientField(ownProps.installationGroup, key, value)),
    setActiveInstallationGroup: (installationGroup) => dispatch(actions.installation.setActiveInstallationGroup(installationGroup))
  };
}

const getInitialImage = (installationGroup) => {
  let image = null;
  if(installationGroup.customImageUrl) {
    image = installationGroup.customImageUrl;
  } else if(installationGroup.image) {
    image = installationGroup.image;
  }
  if(image) {
    return image;
  }
  return null;
}

class projectScopeCard extends PureComponent {
  setInitialState = (props) => {
    this.setState({
      showInformation: false,
      customDisplayName: props.updatedInstallationGroup.customDisplayName || props.updatedInstallationGroup.featureGroup,
      customDescription: props.updatedInstallationGroup.customDescription || helpers.getFeatureGroupDescription(props.updatedInstallationGroup.featureGroup),
      customImageUrl: getInitialImage(props.updatedInstallationGroup),
      defaultDisplayName: props.updatedInstallationGroup.name,
      defaultDescription: props.updatedInstallationGroup.description,
      editingDisplayName: false,
      editingDescription: false,
      editingImageUrl: false,
      acceptIncomingChanges: false,
      enabled: props.updatedInstallationGroup.enabled,
      visible: props.updatedInstallationGroup.visible
    }, this.forceUpdate);
  }

  isSelectedImage = (image) => {
    let url = helpers.getFeatureGroupIconURL(this.props.updatedInstallationGroup.name, this.props.updatedInstallationGroup.enabled);
    if(this.state.customImageUrl) {
      url = helpers.getFeatureGroupIconURL(this.state.customImageUrl, this.props.updatedInstallationGroup.enabled);
    } 
    return _.endsWith(url, `/${image.replace('.svg', '') + '.svg'}`);
  }

  getImageUrl = () => {
    if(this.state.customImageUrl) {
      return helpers.getFeatureGroupIconURL(this.state.customImageUrl, this.props.updatedInstallationGroup.enabled);
    }
    return helpers.getFeatureGroupIconURL(this.props.updatedInstallationGroup.name, this.props.updatedInstallationGroup.enabled);
  }

  updateField = (key, value) => {
    this.setState({[key]: value}, () => this.props.onUpdateTransientField(key, value));
  }

  onChangeEnabled = (enabled) => {
    this.updateField('enabled', enabled);
  }

  onChangeVisible = (visible) => {
    this.updateField('visible', visible);
  }

  startEdit = (key) => {
    var newState = {
      ["editing" + key]: true
    };

    if(key == "DisplayName" && (!this.state.customDisplayName || this.state.customDisplayName.length == 0)) {
      newState.customDisplayName = this.props.updatedInstallationGroup.name;
    } else if(key == "Description" && (!this.state.customDescription || this.state.customDescription.length == 0)) {
      newState.customDescription = this.props.updatedInstallationGroup.description;
    }

    this.setState(newState, () => {
      let el = this["input" + key];
      if(el && el.focus) {
        el.focus();
        el.selectionStart = el.selectionEnd = el.value.length;
      }
    });
  }

  stopEdit = (key, value) => {
    this.setState({["editing" + key]: false, ["custom" + key]: value});
    let field = "";
    switch(key) {
      case "ImageUrl":
        field = "customImageUrl";
      break;
      case "DisplayName":
        field = "customDisplayName";
      break;
      case "Description":
        field = "customDescription";
      break;
    }
    this.updateField(field, value);
  }

  getInfoButton = () => {
    return [{
      text: 'OK',
      onClick: () => {
        this.setState({showInformation: false});
      }
    }];
  }

  hideIconLibrary = () => {
    if(this.editingImageUrl) {
      this.setState({editingImageUrl: false});
    }
  }

  setAcceptIncomingChanges = () => this.setState({acceptIncomingChanges: true});
  componentWillMount() {
    this.setInitialState(this.props);
  }

  componentDidMount() {
    document.addEventListener("transientUpdatesCleared", this.setAcceptIncomingChanges);
    document.addEventListener("newInstallationGroupAdded", this.setAcceptIncomingChanges);
    document.addEventListener("click", this.hideIconLibrary);
  }
  componentWillUnmount() {
    document.removeEventListener("transientUpdatesCleared", this.setAcceptIncomingChanges);
    document.removeEventListener("newInstallationGroupAdded", this.setAcceptIncomingChanges);
    document.removeEventListener("click", this.hideIconLibrary);
  }
  componentDidUpdate(props) {
    if(this.state.acceptIncomingChanges) {
      this.setInitialState(props);
    }
  }

  goToInstallation = () => {
    console.log(this.props.installationGroup);
    this.props.setActiveInstallationGroup(this.props.installationGroup);
    hashHistory.push('installations/items');
  }

  render = template
}

projectScopeCard.propTypes = {
  installationGroup: PropTypes.object.isRequired,
  onUpdateTransientField: PropTypes.func.isRequired
}

const InstallationCard = connect(mapStateToProps, mapDispatchToProps)(projectScopeCard);

export default InstallationCard;
